import { lazy, Suspense } from "react";
import { Navigate, createBrowserRouter } from "react-router-dom";
import ErrorBoundary from "../components/ErrorBoundary"; // Make sure to create this component
import Loader from "../components/Loader"; 
import Activities from "../pages/dossier/Activities";

const DossierList = lazy(() => import("../pages/dossier/DossierList"));
const DossierAdd = lazy(() => import("../pages/dossier/DossierAdd"));
const DossierEdit = lazy(() => import("../pages/dossier/DossierEdit"));
const DossierDocument = lazy(() => import("../pages/dossier/DossierDocument"));
const DistributionList = lazy(() => import("../pages/dossier/Distribution"));
const Dependency = lazy(() => import("../pages/dossier/Dependency"));
const Contents = lazy(() => import("../pages/dossier/Contents"));
const Reports = lazy(() => import("../pages/dossier/Reports"));
const Dms = lazy(() => import("../pages/dossier/Dms"));
const PlanTrack = lazy(() => import("../pages/dossier/PlanTrack"));
const Products = lazy(() => import("../pages/products"));
const Registrations = lazy(() => import("../pages/registrations"));
const TrackandPlan = lazy(() => import("../pages/trackandplan"));
const ProdActivities = lazy(() => import("../pages/products_activities"));
const RegActivities = lazy(() => import("../pages/reg_activities"));
const LinkedRecords = lazy(() => import("../pages/dossier/LinkedRecords"));
const DocsLinkedRecords = lazy(() => import("../pages/dossier/DocsLinkedRecords"));
const ActivitiesPage = lazy(() => import("../pages/dossier/Activities"));

const DocumentManager = lazy(() => import("../pages/dossier/DocumentManager"));
const DocManagerEdit = lazy(() => import("../pages/dossier/EditDocumentManager"));
const DocManagerEdit1 = lazy(() => import("../pages/dossier/EditDocNomenclature"));
const DocManagerEdit2 = lazy(() => import("../pages/dossier/EditDocMPC"));


const routesForm = [
  {
    path: "*",
    element: (
      <Navigate to="dossier" />
    ),
  },
  
  {
    path: "products",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <Products />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  
  {
    path: "productactivities",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <ProdActivities />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "documentmanager",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <DocumentManager />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "registrations",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <Registrations />
        </Suspense>
      </ErrorBoundary>
    ),
  },{
    path: "registrationsactivities",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <RegActivities />
        </Suspense>
      </ErrorBoundary>
    ),
  }, {
    path: "trackandplan",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <TrackandPlan />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "dossier/linkedrecords",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <LinkedRecords />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "dossier/docslinkedrecords",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <DocsLinkedRecords />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "dossier/activities",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <ActivitiesPage />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  // {
  //   path: "dossier",
  //   element: (
  //     <ErrorBoundary>
  //       <Suspense fallback={<Loader />}>
  //         <Dossier />
  //       </Suspense>
  //     </ErrorBoundary>
  //   ),
  // },
  {
    path: "dossier",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <DossierList />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "dossier/add-dossier",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <DossierAdd />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "dossier/edit-dossier",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <DossierEdit />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "documentmanager/edit-documentmanager",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <DocManagerEdit />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "documentmanager/edit-doc-nomenclature",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <DocManagerEdit1 />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "documentmanager/edit-docu-mpc",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <DocManagerEdit2 />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "dossier/dossierdocument",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <DossierDocument />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "dossier/distribution",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <DistributionList />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "dossier/dependency",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <Dependency />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "dossier/content",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <Contents />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "dossier/Reports",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <Reports />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "dossier/documents",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <Dms />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "dossier/PlanTrack",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <PlanTrack />
        </Suspense>
      </ErrorBoundary>
    ),
  },

];

const Router = createBrowserRouter(routesForm);

export { Router };